import React from 'react';
import './MainContent.css';
import { useSelector } from 'react-redux';
import Dashboard from './Dashboard/Dashboard';
import Documents from './Documents/documents';
import Messages from '../../../Messages/messages';

const MainContent = ({layoutType}) => {

    const tab = useSelector(state => state.layout.dashboardTab);

    return (
        <div className='workflow-main-content'>
            { tab === 'dashboard' && <Dashboard layoutType={layoutType} /> }
            { tab === 'messages' && <Messages /> }
            { tab === 'documents' && <Documents /> }
        </div>
    )
}

export default MainContent
